import { List } from '@mui/material';
import AccordionFamilyData from './accordion-cohabitation-data';
import AccordionHistorianFamilyData from './accordion-historian-cohabitation-data';
import AccordionHistorianAddress from './accordion-historian-address';
import AccordionHistorianPeole from './accordion-historian-people';

interface CancellationDueDeathContentProps {
  isEdit?: boolean;
}
const CancellationDueDeathContent = ({
  isEdit,
}: CancellationDueDeathContentProps): React.ReactElement => {
  return (
    <List style={{ overflow: 'auto', minHeight: '100%' }}>
      <AccordionFamilyData />
      <AccordionHistorianFamilyData isEdit={isEdit} />
      <AccordionHistorianAddress isEdit={isEdit} />
      <AccordionHistorianPeole />
    </List>
  );
};

CancellationDueDeathContent.displayName = 'Cancellation due death page content';

export default CancellationDueDeathContent;
